import { prop } from 'ramda';
import { createSelector } from 'reselect';
import { createIntl } from 'react-intl';

export const getLanguage = prop('language');
export const getLocale = createSelector(
  getLanguage,
  prop('locale'),
);
export const getRegion = createSelector(
  getLanguage,
  prop('region'),
);
export const getMessages = createSelector(
  getLanguage,
  prop('messages'),
);

export const getIntl = createSelector(
  getLocale,
  getMessages,
  (locale, messages) => createIntl({ locale, messages: messages[locale] }),
);
